import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";
import { ICONS } from "../icons.map";
import {
  InvestigateSingleEntity,
  ManageEntityTrustMenuItem,
} from "../menu-items";
import { POPULATION_TYPE } from "../models";
import { EventBusListenerArgs } from "./model";
import { SharedState } from "../state";

const TRUST_MANAGED_ENTITIES = [
  POPULATION_TYPE.ORGANIZATION,
  POPULATION_TYPE.DEPARTMENT,
  POPULATION_TYPE.EMPLOYEE,
  POPULATION_TYPE.PRIVATE_EMAIL,
];

export const bus_entity_menu_listener = (): EventBusListenerArgs => [
  "showEntityMenu",
  async (p: {
    item: { name: string; id: string; type: POPULATION_TYPE };
    event: MouseEvent;
  }) => {
    const menu: DrillDownMenuItem[] = [
      InvestigateSingleEntity(ICONS.ENTITIES.get(p.item.type))(p.item.name),
    ];

    if (TRUST_MANAGED_ENTITIES.includes(p.item.type)) {
      menu.push(ManageEntityTrustMenuItem(p.item.id));
    }
    const res = await UseDrillDownMenu().show({
      menu,
      event: p.event,
    });

    if (res.didUserSelectedAnAction) {
      switch (res.actionSelected) {
        case "investigate_entity":
          if (p.item.type === POPULATION_TYPE.FILE) {
            SharedState.investigation.investigate({
              ...p.item,
              type: POPULATION_TYPE.FILE,
            });
          } else {
            SharedState.investigation.investigate({
              ...p.item,
            });
          }
          break;
        case "manage_" + p.item.id:
          // alert("manage trust for " + p.item.id);
          break;
        default:
          break;
      }
    }
  },
];
